module.exports = __webpack_public_path__ + "img/close.253fd227.png";